<template>
    <section class="herosection-new">
        <div class="hero-outwrap">
            <div class="container">
                <div class="hero-inwrap">
                    <div class="row logo-header">
                        <div class="partner intel">
                            <img src="/assets/images/icons/intel.svg"/>
                        </div>
                        <div class="partner intel">
                            <img src="/assets/images/icons/compitacenter.svg"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col xl4 l5 m7">
                            <h3 class="title">{{hero.title}}</h3>
                            <div class="description">
                                {{hero.description}}
                            </div>

                            <router-link class="gocreate"
                                         :to="{ name: 'Digitalplace' }">
                               GO
                            </router-link>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'Herosection2',
        data() {
            return {
                hero: this.globalData.landing.hero,
            }
        },
        mounted() {

        },
        methods: {
            scrollMeTo() {
                var element = document.getElementById('env-homesection');
                element.scrollIntoView({ behavior: 'smooth' })
            }
        },
        components: {

        }
    }


</script>